import Spinner from "react-bootstrap/Spinner";
import { Card, Table, Row, Col, Pagination } from "react-bootstrap";
import { useTable, usePagination, useSortBy, TableOptions } from "react-table";

const PaginationTable = (props: TableOptions<Record<string, unknown>>) => {
  const {
    columns,
    data,
    isLoading,
    sortBy,
    controlledPageSize,
    onTrClick,
    paginationEnabled,
  } = props;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      defaultCanSort: true,
      initialState: {
        pageIndex: 0,
        pageSize: controlledPageSize || 10,
        sortBy: sortBy || [],
      },
    },
    useSortBy,
    usePagination
  );

  return (
    <Card className="float-none table-responsive">
      <Card.Body>
        <Table striped hover {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {!page.length && isLoading ? (
              <tr>
                <td colSpan={10} className="text-center">
                  <Spinner animation="border" role="status" size="sm">
                    <span className="visually-hidden">Nalagam...</span>
                  </Spinner>
                </td>
              </tr>
            ) : !page.length ? (
              <tr>
                <td colSpan={10} className="text-center">
                  <span>Ni podatkov...</span>
                </td>
              </tr>
            ) : (
              page.map((row: any, i: any) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    onClick={() => onTrClick && onTrClick(row)}
                  >
                    {row.cells.map((cell: any) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>

        {paginationEnabled !== false && (
          <Row className="mt-3">
            <Col md="6">
              <span className="mx-2">
                Stran{" "}
                <strong>
                  {pageIndex + 1} od {pageCount}
                </strong>
              </span>
            </Col>
            <Col md="6">
              <Pagination className="float-end">
                <Pagination.First
                  onClick={() => gotoPage(0)}
                  disabled={!canPreviousPage}
                />
                <Pagination.Prev
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                />
                <Pagination.Next
                  onClick={() => nextPage()}
                  disabled={!canNextPage}
                />
                <Pagination.Last
                  onClick={() => gotoPage(pageCount - 1)}
                  disabled={!canNextPage}
                />
              </Pagination>
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

export default PaginationTable;
